"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _index = require("./index.styles");

var _excluded = ["name"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var MobileSubNavigation = function MobileSubNavigation(_ref) {
  var LinkComponent = _ref.LinkComponent,
      ariaLabel = _ref.ariaLabel,
      items = _ref.items,
      closeFunction = _ref.closeFunction;
  var refList = (0, _react.useRef)();

  var closeDelayed = function closeDelayed() {
    return setTimeout(function () {
      return closeFunction();
    }, 200);
  };

  (0, _react.useEffect)(function () {
    if (refList.current) refList.current.firstChild.firstChild.focus();
  });
  return /*#__PURE__*/_react["default"].createElement(_index.Wrapper, {
    role: "dialog",
    "aria-label": ariaLabel
  }, /*#__PURE__*/_react["default"].createElement(_index.Header, null, /*#__PURE__*/_react["default"].createElement(_index.CloseButton, {
    onClick: closeFunction
  })), /*#__PURE__*/_react["default"].createElement(_index.List, {
    ref: refList
  }, items.map(function (_ref2) {
    var name = _ref2.name,
        props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_index.ListItem, {
      key: name
    }, /*#__PURE__*/_react["default"].createElement(_index.Link, (0, _extends2["default"])({
      as: LinkComponent,
      onClick: closeDelayed
    }, props), name, /*#__PURE__*/_react["default"].createElement(_index.IconChevronRight, null)));
  })));
};

MobileSubNavigation.propTypes = {
  LinkComponent: _propTypes.elementType.isRequired,
  pathname: _propTypes.string,
  ariaLabel: _propTypes.string.isRequired,
  mobileMoreText: _propTypes.string,
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    name: _propTypes.string.isRequired,
    Icon: _propTypes.elementType,
    to: _propTypes.string.isRequired
  })).isRequired,
  closeFunction: _propTypes.func
};

var noop = function noop() {};

MobileSubNavigation.defaultProps = {
  closeFunction: noop
};
var _default = MobileSubNavigation;
exports["default"] = _default;